/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type DuplicateProgramMutationVariables = Types.Exact<{
  input: Types.DuplicateProgramInput;
}>;

export type DuplicateProgramMutation = {
  __typename?: 'mutation_root';
  duplicate_program?: { __typename?: 'ProgramOutput'; id: string } | null;
};

export const DuplicateProgramDocument = `
    mutation DuplicateProgram($input: DuplicateProgramInput!) {
  duplicate_program(input: $input) {
    id
  }
}
    ` as string & TypedDocumentNode<DuplicateProgramMutation, DuplicateProgramMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    DuplicateProgram: build.mutation<DuplicateProgramMutation, DuplicateProgramMutationVariables>({
      query: (variables) => ({ document: DuplicateProgramDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useDuplicateProgramMutation } = injectedRtkApi;
